import { useRef } from 'react'
import { motion } from 'framer-motion'
import { useInView } from '../../hooks/useInView'
import ctaIcon from '../../assets/cta-04.svg'

const stagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
}

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.38, 0.005, 0.215, 1] as const,
    },
  },
}

export default function CTASection() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { threshold: 0.3 })

  return (
    <section ref={ref} className="rounded-section bg-oak-yellow py-24 md:py-40">
      <motion.div
        className="mx-auto flex max-w-content flex-col items-center px-6 text-center"
        variants={stagger}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
      >
        <motion.h2
          variants={fadeUp}
          className="font-serif text-[16vw] leading-[0.85] tracking-[-2.88px] text-oak-black md:text-[clamp(48px,8vw,108px)]"
        >
          Signals that matter
        </motion.h2>

        <motion.p
          variants={fadeUp}
          className="mt-8 max-w-[570px] text-[clamp(16px,2vw,26px)] font-medium leading-[1.19] tracking-[-0.26px] text-oak-black md:mt-12"
        >
          Wherever your products go, Oak tracks what's working and brings it back to you.
        </motion.p>

        <motion.div variants={fadeUp} className="mt-10 md:mt-16">
          <a
            href="#demo"
            className="inline-flex items-center gap-3 rounded-pill border border-gray-200 bg-white px-6 py-3.5 text-[clamp(16px,1.5vw,21px)] font-medium tracking-[-0.63px] text-black transition-all hover:shadow-lg"
          >
            Request a Demo
            <img src={ctaIcon} alt="" className="h-8 w-8" />
          </a>
        </motion.div>
      </motion.div>
    </section>
  )
}
